import client from './client';

/**
 * 예산비중도 내 카테고리별 통계 데이터
 */
export const budgetCategoryList = (param) =>
  client.get(`/api/report/budget/category`, param);

/**
 * 예산비중도 비중도 페이지 그래프
 */
export const budgetCategoryGraph = (param) =>
  client.get(`/api/report/budget/category/graph`, param);

/**
 * 예산비중도 일자별 팝업 그래프
 */
export const budgetDayGraph = (param) =>
  client.get(`/api/report/budget/day/graph`, param);

/**
 * 예산비중도 카테고리 일자별 상세 통계
 */
export const budgetCategoryDetail = (param) =>
  client.get(`/api/report/budget/category/detail`, param);

/**
 * 예산비중도 내 타겟팅별 통계 데이터
 */
export const budgetTargeting = (param) =>
  client.get(`/api/report/budget/targeting`, param);

/**
 * 예산비중도 타겟팅 일자별 상세 통계
 */
export const budgetTargetingDetail = (param) =>
  client.get(`/api/report/budget/targeting/detail`, param);
